module.exports = __webpack_public_path__ + "media/envio_encomenda.c663aae5.mp4";